let data16;
if (typeof window === "undefined") {
  data16 = require("../static-s16/Data.json");
} else {
  // data16 = require("../static-s16/Data.json");
  // window.data16 = data16;
  data16 = window.data16;
}

export { data16 };
